const readCookie = (name: string): string | null => {
  if (typeof document === 'undefined' || !document.cookie) {
    return null;
  }
  const encodedName = `${encodeURIComponent(name)}=`;
  const parts = document.cookie.split(';');
  for (const rawPart of parts) {
    const part = rawPart.trim();
    if (!part.startsWith(encodedName)) {
      continue;
    }
    const rawValue = part.slice(encodedName.length);
    try {
      return decodeURIComponent(rawValue);
    } catch {
      return rawValue;
    }
  }
  return null;
};

export const readCsrfToken = (): string | null => readCookie('csrf_token');

export const withCsrfHeader = (headers: HeadersInit = {}): Headers => {
  const merged = new Headers(headers);
  const csrf = readCsrfToken();
  if (csrf) {
    merged.set('x-csrf-token', csrf);
  }
  return merged;
};
